<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="套餐项目id" prop="positionProjectId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.positionProjectId" placeholder="请填写套餐项目id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="单价" prop="price"
                :rules="[
                 ]">
              <el-input v-model="inputForm.price" placeholder="请填写单价"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="材料-计价最低用量" prop="minUsage"
                :rules="[
                 ]">
              <el-input v-model="inputForm.minUsage" placeholder="请填写材料-计价最低用量"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="损耗率" prop="rateNum"
                :rules="[
                 ]">
              <el-input v-model="inputForm.rateNum" placeholder="请填写损耗率"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="损耗率描述" prop="rateDesc"
                :rules="[
                 ]">
              <el-input v-model="inputForm.rateDesc" placeholder="请填写损耗率描述"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="材料方案id" prop="makeupId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.makeupId" placeholder="请填写材料方案id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="材料id" prop="itemId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.itemId" placeholder="请填写材料id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="可选材料ids" prop="isItemSelectIds"
                :rules="[
                 ]">
              <el-input v-model="inputForm.isItemSelectIds" placeholder="请填写可选材料ids"     ></el-input>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmSetMealPositionProjectItemService from '@/api/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItemService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameCn: '',
          positionProjectId: '',
          price: '',
          minUsage: '',
          rateNum: '',
          rateDesc: '',
          makeupId: '',
          itemId: '',
          isItemSelectIds: ''
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建UM套餐空间项目材料关联表`
        } else if (method === 'edit') {
          this.title = '修改UM套餐空间项目材料关联表'
        } else if (method === 'view') {
          this.title = '查看UM套餐空间项目材料关联表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmSetMealPositionProjectItemService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmSetMealPositionProjectItemService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
